module.exports = __webpack_public_path__ + "img/role01.dd7eb273.png";